// MUI X date/time pickers — align with brand (green) and refine clock UI

export default function XDatePickers(theme) {
  const p = theme.vars?.palette?.primary ?? theme.palette.primary;

  const selectedItem = {
    borderRadius: 10,
    fontWeight: 600,
    '&.Mui-selected': {
      backgroundColor: p.main,
      color: p.contrastText,
      boxShadow: '0 2px 10px rgba(31, 91, 64, 0.28)',
      '&:hover, &:focus-visible': {
        backgroundColor: p.dark
      }
    },
    '&:hover:not(.Mui-selected)': {
      backgroundColor: theme.vars
        ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.08)`
        : 'rgba(31, 91, 64, 0.08)'
    }
  };

  return {
    MuiPickerPopper: {
      styleOverrides: {
        paper: {
          borderRadius: 14,
          border: '1px solid rgba(31, 91, 64, 0.08)',
          boxShadow: '0 8px 32px rgba(15, 45, 32, 0.1), 0 2px 8px rgba(15, 45, 32, 0.05)',
          overflow: 'hidden'
        }
      }
    },
    MuiMultiSectionDigitalClock: {
      styleOverrides: {
        root: {
          borderBottomColor: 'rgba(31, 91, 64, 0.08)'
        }
      }
    },
    MuiMultiSectionDigitalClockSection: {
      styleOverrides: {
        root: {
          '&:not(:first-of-type)': {
            borderLeftColor: 'rgba(31, 91, 64, 0.08)'
          }
        },
        item: selectedItem
      }
    },
    MuiDigitalClock: {
      styleOverrides: {
        item: selectedItem
      }
    }
  };
}
